import { Button, Collapse, InputNumber, message, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { CaretDownOutlined } from "@ant-design/icons";
import { connect } from 'react-redux';
import strings from '../../../../../../strings';

const BulkTransfer = ({
    products,
    productIds,
    showModal,
    closeModal,
    cancelSelection,
    sendType
}) => {
    const [ transferLoading, setTransferLoading ] = useState(false);
    const [ quantity, setQuantity ] = useState(null);
    const [ productsToSend, setProductToSend ] = useState([]);
    const [sendInventoryPayload, setSendInventoryPayload] = useState([]);

    const calculateTotalVariantQuantity = (product) => {
        const totalQuant = product.variants.reduce((prev, curr) => {
            return prev + Number(curr.initialQuant);
        }, 0)
        return totalQuant;
    }

    useEffect(() => {
        const productsObj = {};
        for (let i of products) {
          productsObj[i.id] = i;
        }
    
        const productsSend = productIds 
          && productIds
          .map((id) => productsObj[id])
          .filter((prod) => prod.track_inventory && Number(prod.quantity) > 0);
          
          setProductToSend(productsSend);
    }, [productIds]);

    const updateProductQuantity = (id, quantity, variant_id) => {
        if (!quantity) return message.error("Please enter quantity");
        let produtcToUpdate = [...sendInventoryPayload];
    
        function searchAndUpdate(item) {
          if (Array.isArray(item)) {
            item.forEach(searchAndUpdate); 
          } else if (item && typeof item === 'object') {
            if (item.product_id === id && (variant_id === null || item.variant_id === variant_id)) {
              if(quantity > Number(item.initialQuant)) return message.warn("Quantity exceeds product quantity!")
              item.quantity = quantity;
            }
          }
        }
    
        searchAndUpdate(produtcToUpdate);
        setSendInventoryPayload(produtcToUpdate)
    
        // if (productUpdated) {
        //   console.log("Product successfully updated!");
        // } else {
        //   console.warn("No matching product found for update.");
        // }
    };

    useEffect(() => {
    const payload = productsToSend && productsToSend.map((product, index) => {
        
        if(product.variants.length > 0){
        return [
            ...product.variants.map((variant, i) => {
                // variant.business_branch_id = selectedBranch;
                variant.variant_id = variant.id;
                variant.product_id = product.id;
                variant.type = variant.type;
                variant.value = variant.value;
                variant.price = variant.price;
                variant.cost_price =  variant.cost_price;
                variant.initialQuant = variant.quantity;
                variant.quantity = 1;
                delete variant.branch_product_id;
                delete variant.created_at;
                // delete variant.id;
                delete variant.picture;
                delete variant.updated_at;
                return variant;
            })
        ]
        }else return {
            quantity: 1,
            // business_branch_id: selectedBranch,
            product_id: product.id,
        }
    });
    setSendInventoryPayload(payload);
    }, [productsToSend]);
    
    //   useEffect(() => {
    //     if(!selectedBranch) return;
    //     const payload = sendInventoryPayload && sendInventoryPayload.map((product) => {
    //       if(product.length > 0){
    //         return [
    //           ...product.map((variant, i) => {
    //             variant.business_branch_id = selectedBranch;
    //             return variant;
    //           })
    //         ]
    //       }else return {
    //         ...product,
    //         business_branch_id: selectedBranch,
    //       }
    //     });
    //     setSendInventoryPayload(payload);
    //   }, [selectedBranch]);
    const handleSendItem = () => {}
    const handleSendAllItem = () => {}

    const handleAskSEnd = () => Modal.warning({
        title: "Are you sure you want to send inventory?",
        content: "Items sent cannot be reversed",
        onOk: () => sendType === "single" ? handleSendItem() : handleSendAllItem(),
        cancelText: "Cancel",
        closable: true
    })
        
  return (
    <Modal
          open={showModal}
          onCancel={closeModal}
          width={600}
          title="Transfer item(s)"
          footer={[
            <Button onClick={closeModal}>Cancel</Button>,
            <Button
              type="primary"
              onClick={handleAskSEnd}
              loading={transferLoading}
            >
              Send
            </Button>,
          ]}
        >
         
          {/* {sendType === "multiple" && <div>
            <InputNumber style={{width: "100%"}} placeholder={strings.quantity} size="large" onChange={(value) => setQuantity(value)} />
          </div>} */}
          {/* {sendInvType === "single" && <Table columns={columns} dataSource={productsToSend} />} */}
          <div>
          {/* {sendInvType === "single" && productsToSend.length > 0 && productsToSend.map((prod, index) => {
            return */}
             <Collapse
                bordered={false}
                defaultActiveKey={['0']} 
                expandIcon={({ isActive }) => <CaretDownOutlined rotate={isActive ? 180 : 0} />}
                style={{
                    background: "#fff",
                    width: "100%"
                }}
                expandIconPosition="right"
                // key={index}
              >
                 {productsToSend.map((prod, index) => (
                  <Collapse.Panel key={index} style={{backgroundColor:"#f4f4f4", marginBottom: 10, borderRadius: 10}} header={(
                    <div>
                      <p style={{margin:0, fontSize:12, fontWeight:"600"}}>{prod.name}</p>
                      <p style={{margin:0, fontSize:10}} >Total Quantity: {prod.variants.length > 0 ? calculateTotalVariantQuantity(prod): prod.quantity}</p>
                    </div>
                    )}>
                      {prod.variants.length > 0 && (
                        <div>
                          <div style={{display: "flex", alignItems: "center", justifyContent:"space-between"}}>
                            <p style={{margin:0, fontSize:12, fontWeight:"600"}}>Variants</p>
                            <p style={{margin:0, fontSize:12, fontWeight:"600"}}>Qty to send</p>
                          </div>
                          
                          {prod.variants.map((variant, index) => {
                            return (
                              <div key={index} style={{display: "flex", alignItems: "center", justifyContent: "space-between", gap:15}}>
                                <p style={{margin: 0, fontSize:12}}>{variant.type} - {variant.value} ({variant.initialQuant})</p>
                                <InputNumber  
                                  min={1}
                                  max={Number(variant.initialQuant)}
                                  defaultValue={1}
                                  onChange={(val) => {
                                    updateProductQuantity(prod.id, val, variant.id);
                                  }}
                                  size="small"
                                  placeholder="Qty to send"
                                />
                              </div>
                            )
                          })}
                        </div>
                      )}
                      {prod.variants.length === 0 && (
                        <div>
                          <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", gap:15}}>
                            <p style={{margin: 0, fontSize:12}}>{prod.name} ({prod.quantity})</p>
                            <div style={{display: "flex", flexDirection: "column"}}>
                            <p style={{margin:0, fontSize:12, fontWeight:"600", textAlign:"right"}}>Qty to send</p>
                              <InputNumber  
                                min={1}
                                max={Number(prod.quantity)}
                                defaultValue={1}
                                onChange={(val) => {
                                  updateProductQuantity(prod.id, val);
                                }}
                                size="small"
                                placeholder="Qty to send"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    {/* Render specific product details */}
                    {/* <p>{prod.description || "No description available."}</p> */}
                  </Collapse.Panel>
                ))}
              </Collapse>
            
          {/* })} */}
          </div>
         
        </Modal>
  )
}

const mapStateToProps = (state) => ({
  branches: state.branch.allBranches,
  error: state.error,
});
export default connect(mapStateToProps, {
  
})(BulkTransfer);